<img src="assets/images/404.png" alt="404" style="width: 100%">
